import AppLayout from '@/components/layouts/app_layout'

export default function NotFoundPage() {
  return (
    <div className="my-20 text-center font-bold text-xl">
      Opps! The page you were looking wasn't found...
    </div>
  )
}

NotFoundPage.Layout = AppLayout
